module.exports = __webpack_public_path__ + "img/index_icon2@2x.f455cec0.png";